import React from 'react';
import './ForgotPswd.css'


const ForgotPassword = () => {
   

return(
<div>
    <div className="container">
      <img src="../assets/Profile.png" alt="profile-icon" className="profile_ForgotPswd"/>
      <h2 className="forgot_password_ForgotPswd">Forgot Password ?</h2>
      <p className='dont_worry'>Don’t worry! It happens, Please enter the Email ID<br /> We will send the OTP in this Email ID. </p>
      <br />
      <input type="text" placeholder="Enter your Email" name="email" /><br />
      <br />
      <br />
      <button className="continue" type="submit" >Continue</button>
    </div> 
</div>
    )
}

export default ForgotPassword;